var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1025,
    viewBox: "0 0 1440 1025",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440.14 1025.46H-382.119V0.436523H1440.14",
    fill: "#0053C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.14 1025.46H-382.119V0.436523H1440.14",
    fill: "#0053C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.14 1025.02H-382.119V0H1440.14",
    fill: "#0053C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 1025.02H719.06C738.659 997.186 753.408 966.35 761.456 932.401C786.987 824.745 737.102 710.408 660.349 630.703C583.595 550.998 483.02 499.319 384.418 449.074C224.572 367.632 64.7153 286.181 -95.1314 204.739C-101.32 201.588 -97.5516 192.211 -90.908 194.223C161.58 270.502 433.743 247.913 641.006 81.9165C665.588 62.2322 693.605 32.6964 715.814 0H1440V1025.02Z",
    fill: "#407ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.ed0e5d73c55f66afa5cc429b3db8a413.svg";
export { ForwardRef as ReactComponent };